/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

module App.Common {

	export class ErrorDetail {

		constructor(
			public label: string,
			public value: string,
			public html: boolean = false) {}

	}

}